export const ALERT_MESSAGES = {
  TITLE: " Are You Sure ?",
  DESC: "if you delete this already used name will be as it is. if you add new on same name it will be treated as new one.",
};
export const ALERT_BUTTONS = {
  YES: "Yes, Cancel",
  NO: "No, Continue Editing",
};
